import { useCallback } from "react";
import axios from "axios";
import { GENERATE_REPORT } from "./apiUrls";

const useFetchBaseQuery = () => {
  const fetchBaseQuery = useCallback(async (query) => {
    if (!query?.trim()) return null;

    try {
      const { data } = await axios.post(GENERATE_REPORT, { query });
      return data || null;
    } catch (error) {
      console.error("Query Error:", error?.response?.data?.message || error.message);
      return null;
    }
  }, []);

  return fetchBaseQuery;
};

export default useFetchBaseQuery;
